// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FLI6-RW7mH4K5p {\n  font-weight: bold;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontWeightBold": "FLI6-RW7mH4K5p"
};
export default ___CSS_LOADER_EXPORT___;
